import CategoryBar from "@/components/home/CategoryBar";
import HeroSection from "@/components/home/HeroSection";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import NearbyStores from "@/components/home/NearbyStores";
import HowItWorks from "@/components/home/HowItWorks";
import ReferralBanner from "@/components/home/ReferralBanner";

const Index = () => {
  return (
    <div className="min-h-screen">
      <CategoryBar />
      <HeroSection />
      <FeaturedProducts />
      <NearbyStores />
      <HowItWorks />
      <ReferralBanner />
    </div>
  );
};

export default Index;
